// https://github.com/uxitten/polyfill/blob/master/string.polyfill.js
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/padStart
if (!String.prototype.padStart) {
    String.prototype.padStart = function padStart(targetLength,padString) {
        targetLength = targetLength>>0; //truncate if number or convert non-number to 0;
        padString = String((typeof padString !== 'undefined' ? padString : ' '));
        if (this.length > targetLength) {
            return String(this);
        }
        else {
            targetLength = targetLength-this.length;
            if (targetLength > padString.length) {
                padString += padString.repeat(targetLength/padString.length); //append to original to ensure we are longer than needed
            }
            return padString.slice(0,targetLength) + String(this);
        }
    };
}

var application = function() {
    var forms = new forms4i(),
        getAjaxHeader = function() {
            return { "RequestVerificationToken": document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value };
        },
        recaptchaSiteKey = document.getElementById("RecaptchaSiteKey").value,
        recaptchaActionName = document.getElementById("RecaptchaActionName").value,
        errorMsgPanel = '<div id="ErrorBox" class="ErrorMsgPanel" role="alert" aria-atomic="true"><h3 id="ErrorTitle" class="validationHeading">Please correct the following errors and resubmit:</h3>' +
        '<ul id="ErrorMsgBox"><li tabindex="0" class="errorItem"></li></ul></div>',
        init = function() {
            document.getElementById("btnSubmit").addEventListener("click", function(e) {
                //e.preventDefault();
                if(formEvents.ValidateForm()){
               	forms.formValidation(document.getElementById("applicationForm"), ajaxActions.SubmitForm, e);
                } else {
                	return false;
                }                
            });

            var charityApplied = [].slice.call(document.getElementsByName("Charity.Applied"));
            charityApplied.forEach(function(element, index, array) {
        	  	element.addEventListener("change", function(e) {
                		formEvents.SetAppliedDate();
   			});                           
            });
            
            forms.MaskPhoneNumber(document.getElementById("phoneMask"), document.getElementById("Phone"));

            formEvents.SetMinEventDate();
            formEvents.SetLastAppliedDate();

            document.getElementById("txtEventDate").addEventListener("blur", function(e) {
                formEvents.ConfirmFutureDate(this.value);
            });
        },
        formEvents = (function() {
            var setMinEventDate = function() {
            		var minDate = getMinDate();
                    var eventDate = document.getElementById("txtEventDate");
                    eventDate.setAttribute("min", minDate); 
                    eventDate.value = minDate;
                },
                confirmFutureDate = function(dateEntered) {
                	var valid = true;
                	var eventDate = document.getElementById("txtEventDate");
                    eventDate.classList.remove("input-validation-error");
                    eventDate.removeAttribute("aria-invalid");
                    eventDate.parentNode.querySelector(".errorMessage").innerHTML = "";
                    eventDate.parentNode.querySelector(".errorMessage").classList.add("hide");
                    
                    var today = new Date();
                    var parsedDate = new Date(dateEntered);                
                    var validEventDate = addDays(today, 60);
                    
                    if (parsedDate < validEventDate) {
                       valid = false;
                       eventDate.classList.add("input-validation-error");
                        eventDate.setAttribute("aria-invalid", "true");
                       eventDate.parentNode.querySelector(".errorMessage").innerHTML = "Please enter a valid date.";
                       eventDate.parentNode.querySelector(".errorMessage").classList.remove("hide");
                    }
                    
                    return valid;
                },
                getMinDate = function() { // we need at least 60 days notice
                    var today = new Date();
                    var newDate = addDays(today, 61);
                    var dd = String(newDate.getDate()).padStart(2, '0');
                    var mm = String(newDate.getMonth() + 1).padStart(2, '0');
                    var yyyy = newDate.getFullYear();
                    return yyyy + '-' + mm + '-' + dd;
                },
                getYesterdaysDate = function() { // get yesterday's date to deal with time zone differences - matches html min attribute for date range 
                    var today = new Date();
                    var dd = String(today.getDate() - 1).padStart(2, '0');
                    var mm = String(today.getMonth() + 1).padStart(2, '0');
                    var yyyy = today.getFullYear();
                    return yyyy + '-' + mm + '-' + dd;
                },
                addDays = function (date, days) {
			var copy = new Date(Number(date));
			copy.setDate(date.getDate() + days);
			return copy;
		   },
                setAppliedBefore = function() {
                    /* Make sure last applied date is a valid date in the past if the user has applied previously */
                    if (document.getElementById('rdoAppliedYes').checked) {
  				document.getElementById('txtAppliedDate').classList.add('txtReq');
			} else{
				document.getElementById('txtAppliedDate').classList.remove('txtReq');
			}
                },
                setLastAppliedDate = function() {
                    document.getElementById("txtAppliedDate").setAttribute("max", getYesterdaysDate()); 
                },
                validateForm = function() {
                	var valid = true;
                 	/* Make sure event date is a valid date at least 60 days in the future */
                    var lastAppliedDate = document.getElementById('txtAppliedDate');
                    var dateEntered = lastAppliedDate.value;
                    var parsedDate = Date.parse(dateEntered);
                   
                    var today = new Date();
                    
                     if (parsedDate > today) {
                     	valid = false;
                       	appliedDate.classList.add("input-validation-error");
                        	appliedDate.setAttribute("aria-invalid", "true");
                       	appliedDate.parentNode.querySelector(".errorMessage").innerHTML = "Please enter a valid date.";
                       	appliedDate.parentNode.querySelector(".errorMessage").classList.remove("hide");
                    } 
                    
                    var eventDate = document.getElementById("txtEventDate");
                    var futureDate = confirmFutureDate(eventDate.value);
                    if(!futureDate){
                    	 valid = futureDate;
                    }
                    
                    return valid;
                };
            return {
                SetMinEventDate: setMinEventDate,
                ConfirmFutureDate: confirmFutureDate,
                SetAppliedDate: setAppliedBefore,
                SetLastAppliedDate: setLastAppliedDate,
                ValidateForm: validateForm 
            };
        })(),
        ajaxActions = (function() {
            var submitForm = function(event) {
                	//document.getElementById("applicationForm").submit();           
            };
            return {
                SubmitForm: submitForm
            };
        })();

    return {
        Init: init
    };
};

(function() {
    var app = new application();
    app.Init();
})();